import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authenticated: false,
  checkingSSO: false,
  forgotPassword: false,
  forgotSubmitted: false,
  loginFailed: false,
  isLogin: false,
  permissions: null,
  permissionsHierarchy: null,
  user: null,
  usesSSO: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuth(state, action) {
      const { authenticated, loginFailed, user, usesSSO } = action.payload;
      state.authenticated = authenticated;
      state.loginFailed = loginFailed;
      state.user = user;
      state.usesSSO = usesSSO;
    },
    setForgotPassword(state, action) {
      state.forgotPassword = action.payload;
      state.forgotSubmitted = false;
    },
    setForgotSubmitted(state, action) {
      state.forgotSubmitted = action.payload;
    },
    setPermissions(state, action) {
      const { permissions, permissionsHierarchy } = action.payload;
      state.permissions = permissions;
      state.permissionsHierarchy = permissionsHierarchy;
    },
    setUser(state, action) {
      state.user = action.payload.user;
    },
    setIsLogin(state, action) {
      state.isLogin = action.payload;
    },
    checkingSSO(state, action) {
      state.checkingSSO = action.payload;
    },
    setSSO(state, action) {
      state.usesSSO = action.payload;
    },
    cleanUserSlice() {
      return initialState;
    },
  },
});

export const {
  checkingSSO,
  cleanUserSlice,
  setAuth,
  setForgotPassword,
  setForgotSubmitted,
  setIsLogin,
  setPermissions,
  setSSO,
  setUser,
} = userSlice.actions;

export default userSlice.reducer;
